import { render, staticRenderFns } from "./main-page-title.vue?vue&type=template&id=c8d4a45c&scoped=true&"
import script from "./main-page-title.vue?vue&type=script&lang=js&"
export * from "./main-page-title.vue?vue&type=script&lang=js&"
import style0 from "./main-page-title.vue?vue&type=style&index=0&id=c8d4a45c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8d4a45c",
  null
  
)

export default component.exports